import merge from 'lodash/merge.js';

import BaseGradingSchemes from '@/store/modules/base/BaseGradingSchemes.js';

export default merge(BaseGradingSchemes({ name: 'GradingSchemes' }), {});
